import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useCartPriceUIContext } from "../CartPriceUIContext";
import { fetchCartDataPricing } from "../../../actions/cart-pricing/cart";
import Fuse from "fuse.js"

export function CartPriceTable() {

  const [loader, setLoader] = useState(true);

  const { cartPricing } = useSelector(
    (state) => ({
      cartPricing:
        state.cartPricing && state.cartPricing && state.cartPricing.allCart,
    }),
    shallowEqual
  );

  const [searchQuery, setSearchQuery] = useState('');

  const fuse = new Fuse(cartPricing ? cartPricing : [],
    {
      keys: ["plan_name"]
    })

  const results = fuse.search(searchQuery)

  const serchedResult = searchQuery ? results.map((result) => result.item) : cartPricing ? cartPricing : [];

  const handleOnChange = (e) => {
    setSearchQuery(e.target.value)
  }


  const dispatch = useDispatch();

  const priceUIContext = useCartPriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      setIds: priceUIContext.setIds,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      openEditPricePage: priceUIContext.openEditPricePage,
      openDeletePriceDialog: priceUIContext.openDeletePriceDialog,
    };
  }, [priceUIContext]);

  useEffect(() => {

    async function getCart() {
      setLoader(true);

      await dispatch(fetchCartDataPricing(priceUIProps.queryParams));

      setLoader(false);
    }

    getCart();
  }, [priceUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "plan_name",
      text: "Plan Name",
      sort: false,
      // sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "inventory_type",
      text: "Quantity",
      sort: false,
      // sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_price",
      text: "Plan Price",
      sort: false,
      // sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_type",
      text: "Plan Type",
      sort: false,
      // sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },

    {
      dataField: "date",
      text: " Created At",
      sort: false,
      // sortCaret: sortCaret,
      formatter: columnFormatters.CreateDateColumnFormatter,
      style: {
        minWidth: "100px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPricePage: priceUIProps.openEditPricePage,
        openDeletePriceDialog: priceUIProps.openDeletePriceDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];
  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: 25,
    sizePerPageList: sizePerPageList,
    sizePerPage: priceUIProps.queryParams.pageSize,
    page: priceUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
                <div className="col-12">
                  <div class="form-group">
                    <input type="email" class="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search here"></input>
                  </div>
                </div>
              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                // data={products}
                data={serchedResult === null ? [] : serchedResult}
                onTableChange={getHandlerTableChange(
                  priceUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => serchedResult === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader && <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
